import { Shape } from "./global";

type FieldValidation = {
  type: "custom" | string;
  name: string;
  message?: string;
  min?: number;
  max?: number;
  minItems?: number;
  maxItems?: number;
  allowWords?: string[];
};

type CustomValidator = (value: any, validation: FieldValidation) => boolean;

const customValidators: Record<string, CustomValidator> = {
  levels: (value, validation) => {
    if (typeof value !== "string") return false;

    const {
      min = 50,
      max = 300,
      minItems = 1,
      maxItems = 6,
      allowWords = [],
    } = validation;

    const normalisedAllowWords = allowWords.map(word =>
      word.toLowerCase()
    );

    const items = value
      .split(",")
      .map(item => item.trim())
      .filter(Boolean);

    if (items.length < minItems) return false;
    if (items.length > maxItems) return false;

    return items.every(item => {
      if (normalisedAllowWords.includes(item.toLowerCase())) {
        return true;
      }

      const number = Number(item);

      return (
        Number.isFinite(number) &&
        number >= min &&
        number <= max
      );
    });
  },
};

export const validateFields = (
  fields: Shape[] | null,
  values: { [key: string]: any }
) => {
  const errors: {
    key: string;
    message?: string;
  }[] = [];

  if (fields === null) {
    return {
      valid: true,
      errors,
    };
  }

  for (const field of fields) {
    const { key, required, validations = [] } = field;
    const value = values[key];

    if (
      required &&
      (typeof value === "undefined" || value === null || value === "")
    ) {
      errors.push({
        key,
        message: "This field is required",
      });

      continue;
    }

    for (const validation of validations as FieldValidation[]) {
      if (validation.type !== "custom") continue;

      const validator = customValidators[validation.name];

      if (!validator) continue;

      if (!validator(value, validation)) {
        errors.push({
          key,
          message: validation.message,
        });
      }
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};